import { render, staticRenderFns } from "./adultapprates.vue?vue&type=template&id=9b67ff78&"
import script from "./adultapprates.vue?vue&type=script&lang=js&"
export * from "./adultapprates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports